module.exports = __webpack_public_path__ + "static/media/checkbox-inactive.2213cabd.svg";